import { isEqual } from 'lodash';
import { DEFAULT_PAGING } from '../api/ngApiClient/consts';
import { JSONParseCatch } from './JSONParseCatch';
import { INgSelectorUrlParams, IOrderBy, ISelector } from '@src/models/api';
import { AnyType } from '@src/models/common';

/** Используется для форматирования объекта с URL параметрамаи в NgApiSelector
 * @link formatToSelector */
const formatToUrlParams = ({ predicates, ordering, paging, fields }: ISelector): INgSelectorUrlParams => {
  const urlParams: INgSelectorUrlParams = {};

  if (fields && fields.length > 0) {
    urlParams.fields = JSON.stringify(fields);
  }

  if (paging && !isEqual(DEFAULT_PAGING, paging)) {
    urlParams.paging = JSON.stringify([paging.offset, paging.limit]);
  }

  if (predicates && predicates.length > 0) {
    urlParams.predicates = JSON.stringify(
      predicates.map((item) => {
        return [item.field, item.operator, item.values];
      }),
    );
  }

  if (ordering && ordering.length > 0) {
    urlParams.ordering = JSON.stringify(
      ordering.map((item) => {
        return [item.field, item.sortOrder];
      }),
    );
  }

  return urlParams;
};

/** Используется для форматирования селектора NgApi из объекта с URL параметрамаи
 * @link formatToUrlParams */
const formatToSelector = ({ fields, predicates, paging, ordering }: INgSelectorUrlParams): ISelector => {
  const selector: ISelector = {};

  if (paging) {
    const { result, hasError } = JSONParseCatch(paging);

    if (!hasError) {
      selector.paging = {
        offset: result[0],
        limit: result[1],
      };
    }
  }

  if (ordering) {
    const { result, hasError } = JSONParseCatch(ordering);

    if (!hasError) {
      selector.ordering = result.map((item: string[]): IOrderBy => {
        return {
          field: item[0],
          sortOrder: item[1],
        };
      });
    }
  }

  if (predicates) {
    const { result, hasError } = JSONParseCatch(predicates);

    if (!hasError) {
      selector.predicates = result.map((item: AnyType[]) => ({
        field: item[0],
        operator: item[1],
        values: item[2],
      }));
    }
  }

  if (fields) {
    const { result, hasError } = JSONParseCatch(fields);

    if (!hasError) {
      selector.fields = result;
    }
  }

  return selector;
};

/** Утилиты для работы с селекторами из ngApi */
export const NG_SELECTOR = {
  formatToSelector,
  formatToUrlParams,
};
